﻿import {translation} from "@2d-front-monorepo/core";
import {
	initializeMvvmContext,
	LinkButton,
	MvvmButton,
	MvvmDataProvider,
	MvvmTextInput,
	showErrorDialog
} from "@2d-front-monorepo/design-library";
import {PermitsMvvmErrorCollector} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import React, {JSX, useCallback} from "react";
import {useNavigate, useSearchParams} from "react-router";
import {HttpContext} from "../../contexts/HttpContext";
import {useGlobalContext} from "../../hooks/useGlobalContext";
import useEmailRequiredPolicy from "../../policies/emailRequiredPolicy";
import {PublicRoutes} from "../../routes";

type ForgotPasswordProps = {
	email: string;
}

export default function ForgotPassword(): JSX.Element {
	let navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const email = searchParams.get("email");

	const global = useGlobalContext();

	const context = initializeMvvmContext({
		initialState: () => {
			return {
				email: email ?? "",
				password: ""
			};
		}
	});

	const onSubmit = useCallback(async (data: ForgotPasswordProps) => {
		const httpContext = HttpContext.getClient();
		await httpContext.authentication.forgetPassword({
			email: data.email,
			installationId: global.installation.id
			// redirectPath: ""
		});

		showErrorDialog({
			title: {text: PermitTranslations.forgot_password_page__email_sent},
			detail: {text: PermitTranslations.forgot_password_page__email_sent__body},
			errors: []
		}, () => navigate(PublicRoutes.signIn));
	}, []);

	return (
		<section className="sign-in full-layout full-layout--centered">
			<MvvmDataProvider<ForgotPasswordProps> context={context} onSubmit={onSubmit}>
				<h1>{translation(PermitTranslations.forgot_password_page__forget_your_password)}</h1>
				<div className="layout vertical gap">
					<PermitsMvvmErrorCollector/>

					<p>{translation(PermitTranslations.forgot_password_page__instructions)}</p>

					<MvvmTextInput type="email"
					               context={context}
					               property="email"
					               autoComplete="email"
					               autoCapitalize="none"
					               label={translation(PermitTranslations.email)}
					               autoFocus
					               validation={useEmailRequiredPolicy()}/>

					<MvvmButton kind="primary">{translation(PermitTranslations.send)}</MvvmButton>
					<LinkButton to={PublicRoutes.signIn}>{translation(PermitTranslations.cancel)}</LinkButton>
				</div>
			</MvvmDataProvider>
		</section>
	)
}
